import { render, staticRenderFns } from "./TicketBlockMultipleInfo.vue?vue&type=template&id=243f8804"
import script from "./TicketBlockMultipleInfo.vue?vue&type=script&lang=js"
export * from "./TicketBlockMultipleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports